module.exports = __webpack_public_path__ + "static/map-graphic2-a39b9f114f8d1c99648277175c4b22fa.jpg";